export const extractObjectKey = (url: string): string => {
  try {
    // Parse the URL to get the pathname
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;

    // Split the path by '/' and get the last segment (filename)
    const segments = pathname.split("/");
    const filename = segments[segments.length - 1];

    // Remove the file extension
    const objectKey = filename.split(".")[0];

    return objectKey;
  } catch (error) {
    console.error("Error extracting object key:", error);
    return "";
  }
};

export const extractSearchedImage = (url: string): string => {
  try {
    // Parse the URL to get the pathname
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;

    // Split the path by '/' and get the last segment (filename)
    const segments = pathname.split("/");
    const filename = segments[segments.length - 1];

    // Remove the file extension
    const filenameWithoutExt = filename.split(".")[0];

    // Remove the underscore and number suffix (e.g., "_1", "_4")
    const baseKey = filenameWithoutExt.replace(/_\d+$/, "");

    return baseKey;
  } catch (error) {
    console.error("Error extracting object key:", error);
    return "";
  }
};

export function extractFileName(path: string): string {
  // Split by '/' and get the last segment
  const segments = path.split("/");
  const fileName = segments[segments.length - 1];
  return fileName;
}
